/**
 * Service de preferencias de tabela cross-device (Bloco TBL).
 *
 * Reusa o mesmo endpoint singleton `/api/me/dashboard-preferencia` do
 * Bloco VG (Visao Geral). O backend ja aceita PUT partial — entao
 * preferencias_tabelas e widgets sao independentes.
 *
 * Schema (espelha backend):
 *   {
 *     "tabelas": {
 *       "ppcp": {"widths": {"cliente": 240, "ambiente": 180}},
 *       ...
 *     },
 *     "ui": {"precos_solicitados": false}
 *   }
 *
 * Chamadas:
 *   GET   -> {widgets, preferencias_tabelas, atualizado_em}
 *   PUT   body {preferencias_tabelas: {...}}
 *
 * silentError: tratamos erro inline / fallback localStorage (TBL.2).
 */

const URL = "/api/me/dashboard-preferencia";

export function obterPreferenciasTabelas(request) {
  return request(URL, { silentError: true });
}

export function salvarPreferenciasTabelas(request, preferenciasTabelas) {
  return request(URL, {
    method: "PUT",
    body: JSON.stringify({ preferencias_tabelas: preferenciasTabelas }),
    headers: { "Content-Type": "application/json" },
    silentError: true,
  });
}
